import React from 'react'
import { Text } from 'react-native-paper'
import { useBaseTextStyle } from '../../ions/styles'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

export const TextBodySecondary = ({ style, noTopMargin, ...props }) => {
  const { bodySecondary } = useBaseTextStyle()
  return <Text      {...props} style={composeStyle(bodySecondary, style, noTopMargin && { marginTop: 0 })}/>
}
